import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import type {LoggerService} from '@/services/LoggerService/LoggerService';
import type {PlatformService} from '@/services/PlatformService/PlatformService';
import type {Config, GlobalWindow} from '@/types';

export class DevToolsMbService {
  constructor(
    private readonly platformService: PlatformService,
    private readonly globalWindow: GlobalWindow,
    private readonly loggerService: LoggerService,
    private readonly config: Config,
  ) {}

  async initMBDevTools(): Promise<void> {
    if (this.config.isLocal) {
      this.loggerService.log('DevToolsService: skip devtools initialization in local');

      return;
    }

    if (!this.config.isProd && this.platformService.isApp()) {
      await this.initEruda()
        .then(() => this.loggerService.log('DevToolsService: eruda initialized'))
        .catch((e) => this.loggerService.logError('DevToolsService: eruda initialization error', e));
    }
  }

  private initEruda(): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = this.globalWindow.document.createElement('script');
      script.src = 'https://ps-static.cdn-tinkoff.ru/static/common/eruda.js';
      script.type = 'text/javascript';

      script.onload = () => {
        try {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          const eruda = this.globalWindow.eruda;
          eruda.init();
          resolve();
        } catch (e) {
          reject(e);
        }
      };

      this.globalWindow.document.body.appendChild(script);
    });
  }
}

injected(
  DevToolsMbService,
  DI_TOKENS.platformService,
  DI_TOKENS.globalWindow,
  DI_TOKENS.loggerService,
  DI_TOKENS.config,
);
